import React from 'react'
import {change as changeFieldValue, Field, formValueSelector, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import 'moment/locale/pt-br'
import Select from 'react-select';
import DatePicker, {registerLocale, setDefaultLocale} from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import NumberFormat from 'react-number-format';
import $ from 'jquery';
import ptBR from 'date-fns/locale/pt-BR';
import moment from 'moment';
import cadastrarItinerarioPorPeriodo from '../../actions/itinerario/cadastrarItinerarioPorPeriodo'
import alterarItinerario from '../../actions/itinerario/alterarItinerario'
import {
    renderFieldCheck, 
    renderFieldNumerosPorcentagem,
    renderFieldSelect,
    required,
    requiredSelect,
    tamanhoHoraMinuto,
    tamanhoPorcentagem,
    validateHora,
    validateMinutos
} from '../../util/inputs';
import MotoristaItinerario from './MotoristaItinerario';
import {showAlertMsg, showSuccessMsg} from '../../util/messagesUtil';
import BloqueioDescontoItinerario from './BloqueioDescontoItinerario';
import {tipoCategoria, tiposConfiguracoesPreco, tiposConfiguracoesPrecoPrioritario} from '../../util/constantsUtil';
import ModalConfiguracaoCategoriaPoltrona from './ModalConfiguracaoCategoriaPoltrona';
import MapaVeiculoCategoriaPoltrona from './MapaVeiculoCategoriaPoltrona';
import limparVeiculoItinerarioSelecionado from '../../actions/itinerario/limparVeiculoItinerarioSelecionado';
import selecionarVeiculoItinerario from '../../actions/itinerario/selecionarVeiculoItinerario';
import FieldsetBloquearVendedores from './FieldsetBloquearVendedores';
import FieldsetConfiguracaoPreco from './FieldsetConfiguracaoPreco';


const DIAS_SEMANA = [
    {label: 'Dom', value: 'SUNDAY'},
    {label: 'Seg', value: 'MONDAY'},
    {label: 'Ter', value: 'TUESDAY'},
    {label: 'Qua', value: 'WEDNESDAY'},
    {label: 'Qui', value: 'THURSDAY'},
    {label: 'Sex', value: 'FRIDAY'},
    {label: 'Sab', value: 'SATURDAY'},

];

registerLocale('pt-BR', ptBR);
setDefaultLocale('pt-BR');


const renderFieldHora = ({
                             input,
                             label,
                             css,
                             max,
                             readOnly,
                             meta: {touched, error}
                         }) => (
    <div>
        <label className='mt-2'>{label}</label>
        <div>
            <NumberFormat {...input} format="##:##"
                          className={css}
                          maxLength={max}
                          style={{borderColor: touched && error ? 'red' : ''}}
                          readOnly={readOnly}
            />
            {touched
            && (error && <span style={{color: 'red'}}>{error}</span>)}
        </div>
    </div>
);


export class ModalCadastrarItinerarioPorPeriodo extends React.Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.limparFormulario = this.limparFormulario.bind(this);
        this.handleChecked = this.handleChecked.bind(this);
        this.props.changeFieldValue('formularioCadastroItinerarioPorPeriodo','habilitadoSite',
            this.props.empresaSelecionada.habilitadoSite);
        this.props.changeFieldValue('formularioCadastroItinerarioPorPeriodo', 'criarInativo',false);
        this.state = {
            dataInicio: null, dataFim: null, diasSelecionados: [],
            exibeTipoCategoriaUnica: true,
            habilitaConfiguracaoCategoriaPoltrona: false,
            listaCategoriasPoltronas: [],
            tipoPrecoPrimeiroAndarPadrao: null,
            tipoPrecoSegundoAndarPadrao: null,
            andarSelecionado: 1
        }
    }

    criarInativo(e) {
        if (e.target.checked) {
            this.props.changeFieldValue('formularioCadastroItinerarioPorPeriodo', 'criarInativo', false);
        }
    }

    handleExibirCamposAjusteValor(evento) {
        if (evento.target.value) {
            this.props.changeFieldValue('formularioCadastroItinerarioPorPeriodo',
                'valorAjuste', '');
            this.props.changeFieldValue('formularioCadastroItinerarioPorPeriodo',
                'tipoAjusteItinerario', '');
        }
        this.props.changeFieldValue('formularioCadastroItinerarioPorPeriodo',
            'exibirAjuste', evento.target.value);
    }

    handleExibirCamposAjusteValorPrioritario(evento) {
            if (evento.target.value) {
                this.props.changeFieldValue('formularioCadastroItinerarioPorPeriodo',
                    'exibirAjustePrioritario', '');
                this.props.changeFieldValue('formularioCadastroItinerarioPorPeriodo',
                    'tipoAjusteItinerarioPrioritario', '');
            }
            this.props.changeFieldValue('formularioCadastroItinerarioPorPeriodo',
                'exibirAjustePrioritario', evento.target.value);
    }

    selecionarDia(dia) {
        const lista = this.state.diasSelecionados;
        if (lista.includes(dia)) {
            this.setState({diasSelecionados: lista.filter(it => it !== dia)})
        } else {
            lista.push(dia);
            this.setState({diasSelecionados: lista})
        }
    }

    montarParametroItinerario(values) {
        let tipoAjuste = null;
        let valorAjuste = null;
        let tipoPrecoSegundoAndar = null;
        let horaPartidaRegra = null;
        let quantidadePoltronasRegra = null;
        let tipoConfiguracaoPreco = null;
        let tipoConfiguracaoPrecoPrioritario = null;

        if (values.exibirAjuste) {
            tipoAjuste = values.tipoAjusteItinerario.value;
            tipoConfiguracaoPreco = values.tipoConfiguracaoPreco.value;
            valorAjuste = values.valorAjuste ? values.valorAjuste.replace('R$', '') : '0';
            if (tipoConfiguracaoPreco === 'DATA_PARTIDA') {
                horaPartidaRegra = values.horaPartidaRegra;
            }
            if (tipoConfiguracaoPreco === 'POLTRONAS_VENDIDAS_A_CADA' 
                || tipoConfiguracaoPreco === 'POLTRONAS_VENDIDAS_A_PARTIR'
                || tipoConfiguracaoPreco === 'POLTRONAS_VENDIDAS_ATE_NUMERO') {
                quantidadePoltronasRegra = values.quantidadePoltronasRegra;
            }
        }
        if (values.exibirAjustePrioritario) {
            tipoConfiguracaoPrecoPrioritario = values.tipoConfiguracaoPrecoPrioritario ? values.tipoConfiguracaoPrecoPrioritario.value : 'POR_USUARIO'
        } else {
            this.props.limparPricePorUsuario();
        }
        if (this.props.veiculo.value.seDoisAndares) {
            tipoPrecoSegundoAndar = this.state.exibeTipoCategoriaUnica ? values.tipoPrecoSegundoAndar.value : null
        }
        return {
            id: values.idItinerario,
            descontoMaximo: values.descontoMaximo ? values.descontoMaximo.replace('R$', '') : '0.00',
            dataInicio: moment(this.state.dataInicio).format('DD/MM/YYYY'),
            dataFim: moment(this.state.dataFim).format('DD/MM/YYYY'),
            diasSemana: this.state.diasSelecionados,
            idsUsuariosEmpresaMotorista: this.props.motoristasSelecionados ? this.props.motoristasSelecionados.map(it => it.value) : null,
            idsUsuariosEmpresaBloqueio: this.props.usuarioEmpresaBloqueioSelecionados ? this.props.usuarioEmpresaBloqueioSelecionados.map(it => it.value) : null,
            trechosBloqueados: this.props.trechosSelecionados.map(it => (
                {idTrechoOrigem: it.origem.value, idTrechoDestino: it.destino.value}
            )),
            horaSaida: values.horaSaida,
            habilitadoSite: values.habilitadoSite,
            criarInativo: values.criarInativo ? values.criarInativo : false,
            idVeiculo: values.veiculo.value.id,
            idEmpresa: this.props.empresaSelecionada.id,
            idRota: this.props.rotaSelecionada.value,
            trechosBloqueadosDesconto: this.props.trechosBloqueioDescontoSelecionados.map(it => (
                {idTrechoOrigem: it.origem.value, idTrechoDestino: it.destino.value}
            )),
            cidadeBloqueadas: this.props.cidadesSelecionadas.map(it => (
                {idCidade: it.value}
            )),
            valorAjuste,
            tipoAjuste,
            tipoPrecoPrimeiroAndar: this.state.exibeTipoCategoriaUnica ? values.tipoPrecoPrimeiroAndar.value : null,
            tipoPrecoSegundoAndar,
            tipoConfiguracaoPreco,
            horaPartidaRegra,
            quantidadePoltronasRegra,
            idPrestador: values.prestador ? values.prestador.value : null,
            tipoCategoria: this.state.exibeTipoCategoriaUnica ? tipoCategoria.unica.valor : tipoCategoria.mista.valor,
            tipoPrecoPrimeiroAndarPadrao: this.state.tipoPrecoPrimeiroAndarPadrao,
            tipoPrecoSegundoAndarPadrao: this.state.tipoPrecoSegundoAndarPadrao,
            listaCategoriasPoltronas: !this.state.exibeTipoCategoriaUnica ? this.state.listaCategoriasPoltronas.map(it => {
                return {
                    numeroAssento: it.assento.numero,
                    tipoPreco: it.tipoPreco,
                    andar: it.andar
                }
            }) : null,
            tipoConfiguracaoPrecoPrioritario,
            pricePorUsuarioEmpresa: values.exibirAjustePrioritario ? this.props.vendedoresSelecionados.map(it => {
                return {
                    tipoAjuste: it.tipoAjusteItinerario.value,
                    valorAjuste: it.valorAjuste,
                    tipoConifguracaoPreco: it.tipoConfiguracaoPreco ? it.tipoConfiguracaoPreco.value : 'POR_USUARIO',
                    usuarioId: it.id,
                }
            }) : []
        }
    }

    exibirMotoristaItinerario() {
        return <table className="table table-sm table-bordered">
            <thead>
            <tr colSpan='2' className='text-center'>
                <th>Motoristas Selecionados</th>
            </tr>
            </thead>
            <tbody>
            {!this.props.motoristasSelecionados || this.props.motoristasSelecionados.length === 0 ?
                <tr colSpan='2' className="alert alert-warning text-center mt-4" role="alert">
                    <td>Nenhum motorista foi selecionado.</td>
                </tr>
                :
                this.props.motoristasSelecionados
                    .map((motorista, index) => <MotoristaItinerario
                        removerMotorista={this.props.removerMotorista}
                        key={index} motorista={motorista}
                        indice={index}/>)}
            </tbody>
        </table>
    }

    exibirUsuariosVendedoresSelecionados() {
        return <table className="table table-sm table-bordered">
            <thead>
                <tr className='text-center'>
                    <th colSpan='5'>Vendedores</th>
                </tr>
                <tr>
                    <th>ID</th>
                    <th>Desconto/Acréscimo</th>
                    <th>Valor(%)</th>
                    <th>Descricao</th>
                    <th />
                </tr>
            </thead>
            <tbody>
                {!this.props.vendedoresSelecionados || this.props.vendedoresSelecionados.length === 0 ?
                    <tr className="alert alert-warning text-center mt-4" role="alert">
                        <td colSpan='5'>Nenhum vendedor foi
                            cadastrado.
                        </td>
                    </tr>
                    :
                    this.props.vendedoresSelecionados
                        .map((vendedor) => <tr key={vendedor.id}>
                            <td>
                                {vendedor.id}
                            </td>                            
                            <td>
                                {vendedor.tipoAjusteItinerario.label}
                            </td>
                            <td>
                                {vendedor.valorAjuste}
                            </td>
                            <td>
                                {vendedor.vendedor.label}
                            </td>
                            <td className='text-center' style={{ cursor: 'pointer', color: 'red' }}>
                                <div
                                    onClick={() => this.props.removerUsuarioVendedor(vendedor.id)}
                                    >Remover
                                </div>
                            </td>
                        </tr>)}
            </tbody>
        </table>        
    }


    fecharModal() {
        $('#modalCadastrarItinerarioPorPeriodo')
            .modal('hide');
        $('#modalCadastrarItinerarioPorPeriodo')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.limparFormulario();
    }

    handleCheckedTipoCategoriaUnica(valor) {
        if (valor) {
            this.setState({ exibeTipoCategoriaUnica: valor });
        } else {
            this.setState({ exibeTipoCategoriaUnica: !this.state.exibeTipoCategoriaUnica });
        }

    }

    preencherListaCategoriasPoltronas(lista) {
        this.setState({ listaCategoriasPoltronas: lista})
    }

    preencherTipoPrechoPrimeiroAndarPadrao(tipo) {
        this.setState({ tipoPrecoPrimeiroAndarPadrao: tipo })
    }

    preencherTipoPrechoSegundoAndarPadrao(tipo) {
        this.setState({ tipoPrecoSegundoAndarPadrao: tipo })
    }

    verificarAndarSelecionado(andarSelecionado) {
        this.setState({ andarSelecionado });
    }

    handleChecked() {
        this.handleCheckedTipoCategoriaUnica();
    }

    exibirCheckboxTipoCategoria() {
        return (
          <div className="col-12 col-sm-2 col-md-2 container-tipo-categoria-unica">
            <label htmlFor='exibeTipoCategoriaUnica'>Tipo Categoria</label>
            <div className='form-group form-check'>
              <input type="radio" name='exibeTipoCategoriaUnica'
                className='form-check-input' onChange={this.handleChecked} value={this.state.exibeTipoCategoriaUnica} checked={this.state.exibeTipoCategoriaUnica} />
              <label className='form-check-label'>{tipoCategoria.unica.descricao}</label>
            </div>
            <div className='form-group form-check'>
              <input type="radio" name='exibeTipoCategoriaUnica'
                className='form-check-input' onChange={this.handleChecked} value={!this.state.exibeTipoCategoriaUnica} checked={!this.state.exibeTipoCategoriaUnica} />
              <label className='form-check-label'>{tipoCategoria.mista.descricao}</label>
            </div>
          </div>
        )
    }

    submit(values) {
        const parametros = this.montarParametroItinerario(values);
        this.props.cadastrarItinerarioPorPeriodo(parametros)
            .then(() => {
                showSuccessMsg('Itinerários cadastrados com sucesso');
                this.fecharModal();
                this.props.buscarItinerarios()
            })
    }


    limparFormulario() {
        this.props.reset('formularioCadastroItinerarioPorPeriodo');
        this.setState({dataInicio: null, dataFim: null, diasSelecionados: [], habilitaConfiguracaoCategoriaPoltrona: true });
        this.props.limparMotoristasSelecionados();
        this.props.limparUsuarioEmpresaBloqueioSelecionados();
        this.props.limparCidadesSelecionadas();
        this.props.limparPricePorUsuario();
        this.props.limparVeiculoItinerarioSelecionado();
        this.handleCheckedTipoCategoriaUnica(true);
        this.verificarAndarSelecionado(1);
        this.props.changeFieldValue('formularioCadastroItinerarioPorPeriodo','habilitadoSite',
            this.props.empresaSelecionada.habilitadoSite)
    }


    exibirComboTipoPreco(name, label) {
        return <div className="col-12 col-sm-4 col-md-4"><Field name={name}
                                                                options={this.props.tiposPreco.map(elemento => ({
                                                                    descricao: elemento.descricaoTipoPreco,
                                                                    nome: elemento.tipoPreco
                                                                }))}
                                                                component={renderFieldSelect}
                                                                label={label}
                                                                placeholder='Selecione a categoria'
                                                                validate={requiredSelect}/></div>
    }

    selecionarData(data, inicio) {
        if (inicio) {
            this.setState({dataInicio: data, dataFim: null})
        } else {
            this.setState({data, dataFim: data})
        }
    }

    exibirCalendario(inicio) {
        let data;

        let minDate = new Date();
        if (inicio) {
            if (this.state.dataInicio) {
                data = moment(this.state.dataInicio)
                    .toDate()
            }
        } else {
            minDate = moment(this.state.dataInicio)
                .add(1, 'days')
                .toDate();
            if (this.state.dataFim) {
                data = moment(this.state.dataFim)
                    .toDate()
            }
        }
        return (
            <div>
                <div className="linha">
                    <DatePicker
                        className='form-control col-md-12'
                        value={data}
                        locale="pt-BR"
                        minDate={minDate}
                        selected={data}
                        startDate={moment(this.state.dataInicio)
                            .toDate()}
                        endDate={moment(this.state.dataFim)
                            .toDate()}
                        disabled={!inicio && !this.state.dataInicio}
                        onChange={date => this.selecionarData(date, inicio)}
                        dateFormat="dd/MM/yyyy"
                        withPortal
                    />
                </div>
            </div>
        )
    }

    exibirDiasSemana() {
        return DIAS_SEMANA.map(it => <p key={it.value}
                                        className={this.state.diasSelecionados.includes(it.value) ? 'dot selected ml-1' : 'dot ml-1'}
                                        onClick={() => this.selecionarDia(it.value)}>{it.label}</p>)
    }

    handleSelecionarMotorista(evento) {
        this.props.selecionarMotorista(evento);
    }

    handleSelecionarVeiculo(evento) {
        this.verificarAndarSelecionado(1);
        this.props.selecionarVeiculoItinerario(evento);
    }

    exibirCidadesSelecionadas() {
        return (
            <table className="table table-sm table-bordered">
            <thead>
            <tr className='text-center'>
                <th colSpan='3'>Cidades Bloqueadas</th>
            </tr>
            <tr>
                <th>Cidade</th>
                <th/>
            </tr>
            </thead>
            <tbody>
            {!this.props.cidadesSelecionadas || this.props.cidadesSelecionadas.length === 0 ?
                <tr className="alert alert-warning text-center mt-4" role="alert">
                    <td colSpan='3'>Nenhuma cidade foi
                        bloqueada.
                    </td>
                </tr>
                :
                this.props.cidadesSelecionadas
                    .map((cidade,i) => <tr key={i}>
                        <td>
                            {cidade.label}
                        </td>
                        <td className='text-center' style={{cursor: 'pointer', color: 'red'}}>
                            <div
                                onClick={() => this.props.removerCidadeSelecionada(cidade.value)}>Remover
                            </div>
                        </td>
                    </tr>)}
                </tbody>
            </table>
        )

    }

    exibirTrechosSelecionados() {
        return <table className="table table-sm table-bordered">
            <thead>
            <tr className='text-center'>
                <th colSpan='3'>Trechos Bloqueados</th>
            </tr>
            <tr>
                <th>Origem</th>
                <th>Destino</th>
                <th/>
            </tr>
            </thead>
            <tbody>
            {!this.props.trechosSelecionados || this.props.trechosSelecionados.length === 0 ?
                <tr className="alert alert-warning text-center mt-4" role="alert">
                    <td colSpan='3'>Nenhum trecho foi
                        bloqueado.
                    </td>
                </tr>
                :
                this.props.trechosSelecionados
                    .map((trecho) => <tr key={trecho.id}>
                        <td>
                            {trecho.origem.label}
                        </td>
                        <td>
                            {trecho.destino.label}
                        </td>
                        <td className='text-center' style={{cursor: 'pointer', color: 'red'}}>
                            <div
                                onClick={() => this.props.removerTrechoSelecionado(trecho.origem.value, trecho.destino.value)}>Remover
                            </div>
                        </td>
                    </tr>)}
            </tbody>
        </table>
    }

    adicionarCidade(event){
        event.preventDefault();
        this.props.adicionarCidades(this.props.cidade);
        this.props.changeFieldValue('formularioCadastroItinerarioPorPeriodo',
        'cidade', null);
    }

    adicionarTrechos(event) {
        event.preventDefault();
        this.props.adicionarTrechos(this.props.trechoOrigem, this.props.trechoDestino);
        this.props.changeFieldValue('formularioCadastroItinerarioPorPeriodo',
            'trechoOrigem', null);
        this.props.changeFieldValue('formularioCadastroItinerarioPorPeriodo',
            'trechoDestino', null);
    }

    adicionarPricePorUsuario(event) {
        event.preventDefault();        
        if (!this.props.valorAjustePrioritario) {
            showAlertMsg('Informe o valor.');
            return;
        }        
        if (!this.props.tipoAjusteItinerarioPrioritario) {
            showAlertMsg('Informe o desconto/acréscimo.');
            return;
        }        
        if (!this.props.vendedores) {
            showAlertMsg('Informe o usuário.');
            return;
        }

        const obj = {id: this.props.vendedores.value, vendedor: this.props.vendedores, valorAjuste: this.props.valorAjustePrioritario, 
            tipoAjusteItinerario: this.props.tipoAjusteItinerarioPrioritario, tipoConfiguracaoPreco: this.props.tipoConfiguracaoPrecoPrioritario };

        this.props.adicionarPricePorUsuario(obj);
        this.props.changeFieldValue('formularioCadastroItinerarioPorPeriodo',
            'vendedores', null);        
    }

    recuperarTrechos() {
        if (this.props.rotas && this.props.rotaSelecionada) {
            return this.props.trechos.sort((n1, n2) => {
                if (n1.ordem > n2.ordem) {
                    return 1;
                }

                if (n1.ordem < n2.ordem) {
                    return -1;
                }

                return 0;
            });
        }
        return []
    }

    render() {
        const {
            handleSubmit, submitting, invalid, pristine
        } = this.props;
        const trechos = this.recuperarTrechos();
        return (
            <div className="modal fade show" id='modalCadastrarItinerarioPorPeriodo' role='dialog'
                 aria-labelledby='modalCadastrarItinerarioPorPeriodo' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-xl'}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>{this.props.idItinerario ? 'Editar Itinerário' : 'Novo Itinerário'}</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                    onClick={this.limparFormulario}>
                                <i className="material-icons">
                                    &#xe5cd;
                                </i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit(this.submit)}>
                                <fieldset className="scheduler-border">
                                    <legend className="scheduler-border">Informações básicas</legend>
                                    <div className="col-12 col-sm-4 col-md-4 mt-2">
                                        <label>Opera em quais dias da semana?</label>
                                        <div className='form-row'>
                                            {this.exibirDiasSemana()}
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-4 col-md-2 mt-2">
                                        <label>Quando começa?</label>
                                        {this.exibirCalendario(true)}
                                    </div>
                                    <div className="col-12 col-sm-4 col-md-2 mt-2">
                                        <label>Quando encerra?</label>
                                        {this.exibirCalendario()}
                                    </div>
                                    <div className="col-6 col-sm-2 col-md-2">
                                        <Field name="horaSaida" type="texto" component={renderFieldHora}
                                               label='Hora de partida'
                                               css="form-control col-md-12" readOnly={false}
                                               validate={[required, validateMinutos, validateHora, tamanhoHoraMinuto]}/>
                                    </div>
                                    <div className="col-12 col-sm-2 col-md-2 mt-3">
                                        <label className='mt-2' />
                                        <Field name='criarInativo' type="checkbox" component={renderFieldCheck}
                                                    label="Criar inativo"
                                                    css="form-check-input" readOnly={false}
                                                    onChange={(e) => this.criarInativo(e)} />
                                    </div>
                                    <div className="col-12 col-sm-2 col-md-2 mt-3">
                                        <label className='mt-2'/>
                                        <Field name='habilitadoSite' type="checkbox" component={renderFieldCheck}
                                               label="Vender no site?"
                                               css="form-check-input"/>
                                    </div>
                                    <div className="col-12 col-sm-4 col-md-4">
                                        <Field name='veiculo'
                                               options={this.props.veiculos.map(elemento => ({
                                                   descricao: elemento.descricao,
                                                   nome: elemento
                                               }))}
                                               component={renderFieldSelect}
                                               label="Veículo"
                                               placeholder='Selecione um veículo' validate={requiredSelect}
                                               disabled={this.props.idItinerario}
                                               onChange={(e) => this.handleSelecionarVeiculo(e)} />
                                    </div>

                                    {this.exibirCheckboxTipoCategoria()}

                                    <div className="col-12 col-sm-4 col-md-4">
                                        <Field name='prestador'
                                               options={this.props.prestadoresSimples.map(elemento => ({
                                                   descricao: elemento.valor,
                                                   nome: elemento.chave
                                               }))}
                                               component={renderFieldSelect}
                                               label="Prestador"
                                               placeholder='Selecione um prestador'/>
                                    </div>
                                </fieldset>

                                {this.state.exibeTipoCategoriaUnica && <fieldset className="scheduler-border">
                                    <legend className="scheduler-border">Configuração categoria</legend>
                                    <div className="col-12 col-sm-12 col-md-12">
                                         {this.exibirComboTipoPreco('tipoPrecoPrimeiroAndar', !this.props.idItinerario && this.props.veiculo && this.props.veiculo.value.seDoisAndares ? 'Categoria 1° andar' : 'Categoria')}
                                        {!this.props.idItinerario && this.props.veiculo && this.props.veiculo.value.seDoisAndares ? this.exibirComboTipoPreco('tipoPrecoSegundoAndar', 'Categoria 2° andar') : ''}
                                    </div>
                                </fieldset>}

                                {!this.state.exibeTipoCategoriaUnica && this.props.veiculo &&
                                <fieldset className="scheduler-border">
                                    <legend className="scheduler-border">Configurações de categorias para poltronas</legend>
                                    <div className="col-12 col-sm-12 col-md-12">
                                        {!this.props.idItinerario && !this.state.habilitaConfiguracaoCategoriaPoltrona ? <button className="btn btn-laranja" onClick={(e) => { e.preventDefault(); this.setState({ habilitaConfiguracaoCategoriaPoltrona: true }) }}>Editar</button>: ''}
                                        {this.state.habilitaConfiguracaoCategoriaPoltrona || this.props.idItinerario ? <ModalConfiguracaoCategoriaPoltrona
                                                idItinerario={this.props.idItinerario}
                                                exibeTipoCategoriaUnica={this.state.exibeTipoCategoriaUnica}
                                                preencherListaCategoriasPoltronas={this.preencherListaCategoriasPoltronas.bind(this)}
                                                preencherTipoPrechoPrimeiroAndarPadrao={this.preencherTipoPrechoPrimeiroAndarPadrao.bind(this)}
                                                preencherTipoPrechoSegundoAndarPadrao={this.preencherTipoPrechoSegundoAndarPadrao.bind(this)}
                                                andarSelecionado={this.state.andarSelecionado}
                                                verificarAndarSelecionado={this.verificarAndarSelecionado.bind(this)} />
                                            : <MapaVeiculoCategoriaPoltrona idItinerario={this.props.idItinerario} andarSelecionado={this.state.andarSelecionado} verificarAndarSelecionado={this.verificarAndarSelecionado.bind(this)} />}
                                    </div>
                                </fieldset>}

                                {!this.state.exibeTipoCategoriaUnica && !this.props.veiculo && <div>
                                    <p style={{color: 'red'}}>Para exibir o mapa selecione um veículo.</p>
                                </div>}

                                <FieldsetConfiguracaoPreco
                                    exibirAjuste={this.props.exibirAjuste}
                                    exibirAjustePrioritario={this.props.exibirAjustePrioritario}
                                    tipoConfiguracaoPreco={this.props.tipoConfiguracaoPreco}
                                    quantidadePoltronasRegra={this.props.quantidadePoltronasRegra}
                                    tipoConfiguracaoPrecoPrioritario={this.props.tipoConfiguracaoPrecoPrioritario}
                                    quantidadePoltronasRegraPrioritario={this.props.quantidadePoltronasRegraPrioritario}
                                    tiposConfiguracoesPreco={tiposConfiguracoesPreco}
                                    tiposConfiguracoesPrecoPrioritario={tiposConfiguracoesPrecoPrioritario}
                                    usuariosVendedores={this.props.usuariosVendedores}
                                    vendedoresSelecionados={this.props.vendedoresSelecionados}
                                    onToggleAjuste={e => this.handleExibirCamposAjusteValor(e)}
                                    onToggleAjustePrioritario={e => this.handleExibirCamposAjusteValorPrioritario(e)}
                                    onAdicionarPricePorUsuario={e => this.adicionarPricePorUsuario(e)}
                                    onRemoverUsuarioVendedor={id => this.props.removerUsuarioVendedor(id)}
                                />

                                <fieldset className="scheduler-border">
                                    <legend className="scheduler-border">Desconto máximo do itinerário</legend>
                                    <div className="col-12 col-sm-2 col-md-2">
                                        <Field name='descontoMaximo' validate={[tamanhoPorcentagem]}
                                            component={renderFieldNumerosPorcentagem}
                                            css="form-control" label="Desconto máximo(%):" />
                                    </div>
                                </fieldset>
                                {this.props.exibirAjuste ?
                                    <BloqueioDescontoItinerario
                                        trechoDestinoBloqueioDesconto={this.props.trechoDestinoBloqueioDesconto}
                                        changeFieldValue={this.props.changeFieldValue}
                                        trechoOrigemBloqueioDesconto={this.props.trechoOrigemBloqueioDesconto}
                                        trechosBloqueioDescontoSelecionados={this.props.trechosBloqueioDescontoSelecionados}
                                        adicionarTrechosBloqueioDesconto={this.props.adicionarTrechosBloqueioDesconto}
                                        removerTrechoBloqueioDescontoSelecionado={this.props.removerTrechoBloqueioDescontoSelecionado}
                                        rotaSelecionada={this.props.rotaSelecionada}
                                        rotas={this.props.rotas}
                                        trechos={trechos}/>
                                    : ''}
                                <fieldset className="scheduler-border">
                                    <legend className="scheduler-border">Bloqueio de venda em trechos</legend>
                                    <div className="col-12 col-sm-9 col-md-5">
                                        <Field name='trechoOrigem'
                                               options={trechos.map(elemento => ({
                                                   descricao: elemento.cidadeDestino.nome,
                                                   nome: elemento.id
                                               }))}
                                               component={renderFieldSelect}
                                               placeholder='Selecione o trecho de origem'/>
                                    </div>
                                    <div className="col-12 col-sm-9 col-md-5">
                                        <Field name='trechoDestino'
                                               options={trechos.map(elemento => ({
                                                   descricao: elemento.cidadeDestino.nome,
                                                   nome: elemento.id
                                               }))}
                                               component={renderFieldSelect}
                                               placeholder='Selecione o trecho de destino'/>
                                    </div>
                                    <div className="col-12 col-sm-3 col-md-1">
                                        <button disabled={!this.props.trechoOrigem || !this.props.trechoDestino}
                                                type="submit" className="btn btn-sm btn-laranja"
                                                onClick={(e) => this.adicionarTrechos(e)}>Incluir
                                        </button>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-10 mt-2">
                                        <div className="lista-table">
                                            {this.exibirTrechosSelecionados()}
                                        </div>
                                    </div>
                                </fieldset>
                                <fieldset className="scheduler-border">
                                    <legend className="scheduler-border">Bloqueio de venda por cidades</legend>
                                    <div className="col-12 col-sm-9 col-md-5">
                                        <Field name="cidade"
                                              options={trechos.map(elemento => ({
                                                descricao: elemento.cidadeDestino.nome,
                                                nome: elemento.cidadeDestino.id
                                            }))}
                                               component={renderFieldSelect}
                                               placeholder='Selecione a cidade'/>
                                    </div>
                                    <div className="col-12 col-sm-3 col-md-1">
                                        <button disabled={!this.props.cidade}
                                                type="submit" className="btn btn-sm btn-laranja"
                                                onClick={(e) => this.adicionarCidade(e)}>Incluir
                                        </button>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-10 mt-2">
                                        <div className="lista-table">
                                            {this.exibirCidadesSelecionadas()}
                                        </div>
                                    </div>
                                </fieldset>
                                <fieldset className="scheduler-border">
                                    <legend className="scheduler-border">Vinculo de motoristas</legend>
                                    <div className="col-12 col-sm-12 col-md-9">
                                        <div>
                                            <Select
                                                ref={this.componentRef}
                                                placeholder='Adicionar motorista'
                                                styles={{
                                                    control: base => ({
                                                        ...base,
                                                        height: 35,
                                                        minHeight: 32,
                                                        fontSize: 16,
                                                        width: '100%',
                                                        borderColor: '#e4e7ea',
                                                        cursor: 'pointer'
                                                    })
                                                }}
                                                value={null}
                                                noOptionsMessage={() => ('Nenhuma opção encontrada')}
                                                options={this.props.motoristas.filter(it => !this.props.motoristasSelecionados.map(it => it.value).includes(it.usuarioEmpresaId))
                                                    .map(elemento => ({
                                                        label: elemento.nome,
                                                        value: elemento.usuarioEmpresaId
                                                    }))}
                                                onChange={e => this.handleSelecionarMotorista(e)}/>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-9 mt-2">
                                        <div className="lista-table">
                                            {this.exibirMotoristaItinerario()}
                                        </div>
                                    </div>
                                </fieldset>
                                <FieldsetBloquearVendedores
                                    usuariosDisponiveis={this.props.usuariosVendedores}
                                    vendedoresSelecionados={this.props.usuarioEmpresaBloqueioSelecionados}
                                    onAdicionar={this.props.selecionarVendedorParaBloquear}
                                    onRemover={this.props.removerUsuarioEmpresaBloqueio}
                                />

                                <div className="modal-footer">
                                    <button type="submit"
                                            disabled={invalid || submitting || pristine || !this.state.dataInicio
                                            || !this.state.dataFim || !this.state.diasSelecionados.length}
                                            className="btn btn-laranja">Salvar
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        initialValues: {
            tipoConfiguracaoPreco: {label: 'Normal', value: 'NORMAL'},
            tipoConfiguracaoPrecoPrioritario: {label: 'Por usuário', value: 'POR_USUARIO'},
            prestador: {label: 'Frota própria', value: ''}
        },
        exibirAjuste: formValueSelector('formularioCadastroItinerarioPorPeriodo')(state, 'exibirAjuste'),
        exibirAjustePrioritario: formValueSelector('formularioCadastroItinerarioPorPeriodo')(state, 'exibirAjustePrioritario'),        
        descontoMaximo: formValueSelector('formularioCadastroItinerarioPorPeriodo')(state, 'descontoMaximo'),
        vendedores: formValueSelector('formularioCadastroItinerarioPorPeriodo')(state, 'vendedores'),
        valorAjuste: formValueSelector('formularioCadastroItinerarioPorPeriodo')(state, 'valorAjuste'),
        tipoAjusteItinerario: formValueSelector('formularioCadastroItinerarioPorPeriodo')(state, 'tipoAjusteItinerario'), 
        tipoAjusteItinerarioPrioritario: formValueSelector('formularioCadastroItinerarioPorPeriodo')(state, 'tipoAjusteItinerarioPrioritario'),
        tipoConfiguracaoPreco: formValueSelector('formularioCadastroItinerarioPorPeriodo')(state, 'tipoConfiguracaoPreco'),
        horaPartidaRegra: formValueSelector('formularioCadastroItinerarioPorPeriodo')(state, 'horaPartidaRegra'),
        quantidadePoltronasRegra: formValueSelector('formularioCadastroItinerarioPorPeriodo')(state, 'quantidadePoltronasRegra'),
        idItinerario: formValueSelector('formularioCadastroItinerarioPorPeriodo')(state, 'idItinerario'),
        veiculo: formValueSelector('formularioCadastroItinerarioPorPeriodo')(state, 'veiculo'),
        assentosDisponiveis: formValueSelector('formularioCadastroItinerarioPorPeriodo')(state, 'assentosDisponiveis'),
        trechoOrigem: formValueSelector('formularioCadastroItinerarioPorPeriodo')(state, 'trechoOrigem'),
        trechoDestino: formValueSelector('formularioCadastroItinerarioPorPeriodo')(state, 'trechoDestino'),
        cidade: formValueSelector('formularioCadastroItinerarioPorPeriodo')(state, 'cidade'),
        trechoOrigemBloqueioDesconto: formValueSelector('formularioCadastroItinerarioPorPeriodo')(state, 'trechoOrigemBloqueioDesconto'),
        trechoDestinoBloqueioDesconto: formValueSelector('formularioCadastroItinerarioPorPeriodo')(state, 'trechoDestinoBloqueioDesconto'),
        valorAjustePrioritario: formValueSelector('formularioCadastroItinerarioPorPeriodo')(state, 'valorAjustePrioritario'),
        tipoConfiguracaoPrecoPrioritario: formValueSelector('formularioCadastroItinerarioPorPeriodo')(state, 'tipoConfiguracaoPrecoPrioritario'),
        horaPartidaRegraPrioritario: formValueSelector('formularioCadastroItinerarioPorPeriodo')(state, 'horaPartidaRegraPrioritario'),
        quantidadePoltronasRegraPrioritario: formValueSelector('formularioCadastroItinerarioPorPeriodo')(state, 'quantidadePoltronasRegraPrioritario'),
        empresaSelecionada: state.empresaSelecionada,
        tiposPreco: state.tiposPreco,
        veiculos: state.veiculos.veiculos,
        paginaAtual: state.paginaAtualItinerario,
        registrosPorPagina: state.registrosPorPaginaItinerario,
        rotaSelecionada: state.rotaSelecionada,
        motoristas: state.motoristas,
        rotas: state.rotas.rotas,
        prestadoresSimples: state.prestadores.prestadoresSimples,
        filtrosAdicionados: state.filtrosAdicionadosItinerario,
        trechos: state.trechos,
        usuariosVendedores: state.usuariosVendedores

    }
}


export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        cadastrarItinerarioPorPeriodo,
        alterarItinerario,
        limparVeiculoItinerarioSelecionado,
        selecionarVeiculoItinerario,
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioCadastroItinerarioPorPeriodo',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(ModalCadastrarItinerarioPorPeriodo));
